import { render, staticRenderFns } from "./jiankangzhuangtai.vue?vue&type=template&id=1b6e8a32&scoped=true&"
import script from "./jiankangzhuangtai.vue?vue&type=script&lang=js&"
export * from "./jiankangzhuangtai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e8a32",
  null
  
)

export default component.exports